var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"pic-select",attrs:{"items":_vm.staffList,"value":_vm.value,"item-text":"name","item-value":"id","dense":"","outlined":"","hide-details":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }